export const DEFAULT_RAMP_OTHERS = 'DEFAULT_RAMP_OTHERS';
export const DEFAULT_SAMPLES = 10;
export const OTHERS_GLSL_VALUE = '(-1.)';
export const OTHERS_INDEX = -1;
export const OTHERS_LABEL = 'CARTO_VL_OTHERS';
export const SORT_DESC = 'DESC';
export const SORT_ASC = 'ASC';
export const DEFAULT_OPTIONS = {
    othersLabel: OTHERS_LABEL,
    samples: DEFAULT_SAMPLES,
    order: SORT_ASC
};

export const FP32_DESIGNATED_NULL_VALUE = -(1 << 24);
